<template>
    <div>
        <novo-emprestimo @startload='showOverlay()' @loaded='loadEmprestimos()' @new='loadEmprestimos()'></novo-emprestimo>
        <card title='Filtros'>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" id="customCheck1" class="custom-control-input" v-model='devolvidos' @change='loadEmprestimosResetandoPagina()'>
            <label class="custom-control-label" for="customCheck1">Mostrar Devolvidos</label>
          </div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox"  id="customCheck2" class="custom-control-input" v-model='atrasados' @change='loadEmprestimosResetandoPagina()'>
            <label class="custom-control-label" for="customCheck2">Mostrar Atrasados</label>
          </div>
          <form @submit.prevent.stop='loadEmprestimosResetandoPagina()'>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Buscar</label>
                <input type="text" name='search' v-model.trim="searchValue" class="form-control border-input" placeholder="Nome">
              </div>
            </div>
          </div>
        </form>
        </card>
        <emprestimo
          v-for="(emprestimo,index) in emprestimos"
          :key='`emprestimo-${index}`'
          :emprestimo="emprestimo"
          @devolver='devolver($event)'
          @desdevolver='desdevolver($event)'
          @renovar='renovar($event)'
          @perdido='perdido($event)'
          @email='email($event)'
          />
        <pagination :count='count' :limit='limit' :page='page' @changePage='changePage($event)'></pagination>
    </div>
</template>
<script>
import EmprestimoService from '../services/emprestimo-service'
import { Pagination } from '@/components'
import OverlayService from '@/services/overlay-service'
import AuthService from '@/services/auth-service'
import NovoEmprestimo from '@/components/Emprestimos/NovoEmprestimo.vue'
import Emprestimo from '@/components/Emprestimos/Emprestimo.vue'

export default {
  components: {
    Pagination,
    NovoEmprestimo,
    Emprestimo
  },
  data () {
    return {
      emprestimos: [],
      limit: 7,
      count: 0,
      page: 0,
      devolvidos: 0,
      atrasados: 0,
      searchValue: null
    }
  },

  computed: {
  },

  watch: {
    '$route.query.page'() {
      this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 0
      this.loadEmprestimos()
    }
  },

  mounted () {
    this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 0
    this.loadEmprestimos()
  },

  methods: {

    showOverlay () {
      OverlayService.trigger('show', true)
    },

    renovar (item) {
      OverlayService.trigger('show', true)

      EmprestimoService.renovar(item.id)
        .then(response => response.data)
        .then(emprestmo => {
          item.renovacoes++
          item.data_limite = emprestmo.data_limite
          item.atrasado = false
          OverlayService.trigger('show', false)
          this.$alertify.success('Renovado com sucesso!')
        })
        .catch(er => {
          let message = 'Erro ao renovar livro'

          if (er.response.data.message) {
            message = this.$t(er.response.data.message)
          }
          this.$alertify.error(message)
          OverlayService.trigger('show', false)
        })
    },

    perdido (item) {
      OverlayService.trigger('show', true)

      const value = !item.perdido

      EmprestimoService.perdido(item.id, value).then(() => {
        item.perdido = value
        OverlayService.trigger('show', false)
        this.$alertify.success('Alterado com sucesso!')
      }).catch(er => {
        this.$alertify.error('Erro ao alterar valor')
        OverlayService.trigger('show', false)
      })
    },

    desdevolver (item) {
      OverlayService.trigger('show', true)

      EmprestimoService.desdevolver(item.id)
        .then(response => response.data)
        .then(emprestmo => {
          item.devolvido = 0
          item.data_devolucao = emprestmo.data_devolucao
          OverlayService.trigger('show', false)
          this.$alertify.success('Devolução revertida!')
        })
        .catch(er => {
          let message = 'Erro ao devolver livro'

          if (er.response.data.message) {
            message = this.$t(er.response.data.message)
          }
          this.$alertify.error(message)
          OverlayService.trigger('show', false)
        })
    },

    devolver(item) {

      OverlayService.trigger('show', true)

      EmprestimoService.devolver(item.id)
        .then(response => response.data)
        .then(emprestmo => {
          item.devolvido = 1
          item.data_devolucao = emprestmo.data_devolucao
          OverlayService.trigger('show', false)

          if (item.reservas.length) {
            this.$alertify.success('Devolvido com sucesso! <br/>Existem reservas para este livro!')
          } else {
            this.$alertify.success('Devolvido com sucesso!')
          }
        })
        .catch(er => {
          let message = 'Erro ao devolver livro'

          if (er.response.data.message) {
            message = this.$t(er.response.data.message)
          }
          this.$alertify.error(message)
          OverlayService.trigger('show', false)
        })
    },

    email (item) {
      OverlayService.trigger('show', true)

      EmprestimoService.email(item.id)
        .then(response => {
          OverlayService.trigger('show', false)
          this.$alertify.success('Email Enviado com sucesso!')
        })
        .catch(er => {
          let message = 'Erro ao enviar email'

          if (er.response.data.message) {
            message = this.$t(er.response.data.message)
          }
          this.$alertify.error(message)
          OverlayService.trigger('show', false)
        })
    },

    loadEmprestimos () {
      const order = [{ orderBy: 'id', direction: 'desc' }]

      const filter = {
        limit: this.limit,
        page: this.page + 1,
        orderBy: order,
        devolvido: this.devolvidos ? 1 : 0,
        atrasado: this.atrasados ? 1 : 0,
        titulo: this.searchValue
      }

      OverlayService.trigger('show', true)

      EmprestimoService.getAll(filter)
        .then(result => result.data)
        .then(emprestimos => {
          this.emprestimos = emprestimos.data
          this.count = emprestimos.total
          OverlayService.trigger('show', false)
        })
        .catch(er => OverlayService.trigger('show', false))
    },

    loadEmprestimosResetandoPagina () {
      this.page = 0
      this.loadEmprestimos()
    },

    getOffset () {
      return this.limit * this.page
    },

    changePage (page) {
      this.page = page
      this.loadEmprestimos()
    }
  }
}
</script>
<style lang="scss" scoped>
  .atrasado {
    background-color: lightcoral;
    color: white;
  }
</style>

